import { render, staticRenderFns } from "./StoriesList.vue?vue&type=template&id=ef0fbca4&"
import script from "./StoriesList.vue?vue&type=script&lang=js&"
export * from "./StoriesList.vue?vue&type=script&lang=js&"
import style0 from "./StoriesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports